import React from 'react';
import './Shop.css'
import pythonscripts from '../assets/images/products/pythonautomationscripts.jpg'
import automationtools from '../assets/images/products/automationtools.jpg'
import modelassets from '../assets/images/products/3dassets.jpg'
import businesstools from '../assets/images/products/businesstools.jpg'
import hackersbundle from '../assets/images/products/hackersbundle.jpeg'
import datasets from '../assets/images/products/datasets.png'
import windowspayloads from '../assets/images/shopprojects/windowspayloads.jpg'
import siteelements from '../assets/images/shopprojects/sitelements.jpg'
import rna3folding from '../assets/images/shopprojects/rna3dfolding.png'
import quantumspinsim from '../assets/images/shopprojects/quantumspinsim.jpg'
import quantumneuralnetsim from '../assets/images/shopprojects/quantumneuralnetsim.jpg'
import quantumentanglesim from '../assets/images/shopprojects/quantumentanglementsim.jpg'
import malpyscripts from '../assets/images/shopprojects/malpyscripts.jpg'
import imageencryptiontool from '../assets/images/shopprojects/imageencryptiontool.jpg'
import dadjokes from '../assets/images/shopprojects/dadjokes.jpg'
import cyberhgienetool from '../assets/images/shopprojects/cyberhygienetool.jpg'
import behaiourdetect from '../assets/images/shopprojects/behaviourdetection.png'
import arduinoscripts from '../assets/images/shopprojects/arduinoscripts.jpg'
import androidpentest from '../assets/images/shopprojects/androidpentest.jpg'
import adblock from '../assets/images/shopprojects/adblock.jpg'
import espsripts from '../assets/images/shopprojects/8266scripts.jpg'
import { Helmet } from 'react-helmet';


const scrollLeft = () => {
  const slider = document.getElementById('catalogSlider');
  slider.scrollBy({ left: -300, behavior: 'smooth' });
};

const scrollRight = () => {
  const slider = document.getElementById('catalogSlider');
  slider.scrollBy({ left: 300, behavior: 'smooth' });
};

function Shoproject() {
  return <div className='shop'>
    <Helmet>
      <title>Aadhaar Koul | Shop Projects</title>
    </Helmet>
      <div className='shop-container'>
        <div className='top-scroll'></div>
        <div className='top-nav'>
          <a href='/shop'><div>Assets</div></a>
          <a href='/shoproject'><div className='current-tab'>Projects</div></a>
          <a href='/code'><div>IOT</div></a>
          <a href='/research'><div>Research</div></a>
          <a href='/books'><div>Books</div></a>
        </div>
        {/* <div className='title1'>
          <h2>Save 75% with Days of Code</h2>
        </div> */}
        <div className='banner'>
          <h2>Projects</h2>
          <p>Explore the premium projects store to elevate your creative workflow.</p>
          <div>
          </div>
        </div>
        <div className='smaller-banner'>
            <h2>Curated Projects</h2>
            <p style={{width:'90%'}}>Explore expertly curated projects to accelerate your workflow — from UI kits and templates to 3D models, AR/VR elements, and more.</p>
        <div>
        </div>
        </div>
        <div className='smaller-banner-text'>
          <div className='smaller-banner-text-content'>
            <h2>Save big with Days of Code</h2>
            <p>Avail up to 75% off on selected digital projects — limited time only. 
            </p>
            <p>Offer Ends : 1st August , 2025</p>
            {/* <button>Find Out More</button> */}
          </div>
        </div>
        <div className='days-of-code'>
          <h2>Days of Code</h2>
          <h4>Save 75% with days of code</h4>
        </div>
        <div className='products'>
          <div className='products-catalog'>
            <div className='product'>
              <div className='product-image'>
                <img src={windowspayloads}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Windows Payloads</div>
                  <div><s>₹999</s> 75% off</div>
                  <div>₹249</div>
                  <a href='https://rzp.io/rzp/uD5qgUMk' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={siteelements}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Site Elements</div>
                  <div><s>₹999</s> 75% off</div>
                  <div>₹249</div>
                  <a href='https://rzp.io/rzp/FGdUU5P' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={rna3folding}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>RNA Folding</div>
                  <div><s>₹1999</s> 75% off</div>
                  <div>₹499</div>
                  <a href='https://rzp.io/rzp/V1FcO5GZ' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={quantumentanglesim}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Quant Entangle</div>
                  <div><s>₹1999</s> 75% off</div>
                  <div>₹499</div>
                  <a href='https://rzp.io/rzp/jV5r6G2Y' ><button>View More</button></a>
                </div>
              </div>
            </div>
          </div>
          <div className='products-catalog'>
            <div className='product'>
              <div className='product-image'>
                <img src={quantumneuralnetsim}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Quant Neural Nets</div>
                  <div><s>₹1999</s> 75% off</div>
                  <div>₹499</div>
                  <a href='https://rzp.io/rzp/EdpwcbKq' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={quantumspinsim}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Quat Spin Sim</div>
                  <div><s>₹1999</s> 75% off</div>
                  <div>₹499</div>
                  <a href='https://rzp.io/rzp/IufjikX' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={malpyscripts}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Malicious Scripts</div>
                  <div><s>₹999</s> 75% off</div>
                  <div>₹249</div>
                  <a href='https://rzp.io/rzp/K5A7V1o' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={imageencryptiontool}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Image Encrypter</div>
                  <div><s>₹399</s> 75% off</div>
                  <div>₹99</div>
                  <a href='https://rzp.io/rzp/5l2o4vL' ><button>View More</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className='days-of-code'>
          <h2>Days of Code</h2>
          <h4>Save 75% with days of code</h4>
        </div>
        <div className='products2'>
          <button className="slide-btn left" onClick={() => scrollLeft()}>&#10094;</button>

          <div className='products2-catalog' id="catalogSlider">
            <a href='https://rzp.io/rzp/CHPAo8w'><div style={{ backgroundImage: `url(${dadjokes})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', }} className='product2'>₹199</div></a>
            <a href='https://rzp.io/rzp/ZkcKXJjx'><div style={{ backgroundImage: `url(${cyberhgienetool})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹399</div></a>
            <a href='https://rzp.io/rzp/ezlaa4ME'><div style={{ backgroundImage: `url(${behaiourdetect})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹399</div></a>
            <a href='https://rzp.io/rzp/OmSvu1U'> <div style={{ backgroundImage: `url(${arduinoscripts})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹99</div></a>
            <a href='https://rzp.io/rzp/xCyPWkc'><div style={{ backgroundImage: `url(${androidpentest})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹399</div></a>
            <a href='https://rzp.io/rzp/CMixGlw'><div style={{ backgroundImage: `url(${adblock})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹99</div></a>
            <a href='https://rzp.io/rzp/MJ9GXU4'><div style={{ backgroundImage: `url(${espsripts})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹99</div></a>
          </div>

          <button className="slide-btn right" onClick={() => scrollRight()}>&#10095;</button>
        </div>
        
        <div className='banner'>
          <h2>Request a Project</h2>
          <p>Looking for a specific Project? Let us know what you need — whether it's a toolkit, template, or resource — and we'll do our best to make it available.</p>
          <div>
          <button>Send Request</button>
          </div>
        </div>
        <div className='title1'>
          <h6>*Requesting a Project may take up to one or two weeks, but rest assured — we’re committed to delivering exactly what you need.</h6>
        </div>
        <div className='title1'>
          <h5>Need help finding the right project?</h5>
          <h5>Get expert guidance on selecting and using digital resources.</h5>
          <h5>Reach out for personalized support and recommendations.</h5>
        </div>
      </div>
    </div>;
}

export default Shoproject;
